import { Component, inject, NgZone } from '@angular/core';
import { recuperarPasswordService } from './recuperarPassword.service';
import { AbstractControl, FormBuilder, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { AppModule } from '../../app-module';
import { paramsInterface, recuperarPassPost, reestablecerPass, responseRecuperarPass } from './recuperarPassword.interface';
import { BaseReponseGeneric } from '../../commons/class/BaseReponseGeneric.interface';
import { ConfirmationDialogService } from '../../commons/components/confirm-dialog/confirm-dialog.service';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { IpService } from '../../commons/services/ipService.service';

@Component({
    selector: 'oaj-recuperar-password-itx',
    templateUrl: './recuperarPassword.component.html',
    styleUrls: ['./recuperarPassword.component.css'],
    providers: [recuperarPasswordService, ConfirmationDialogService],
    imports: [AppModule]
})

export class recuperarPasswordComponent {
    private service: recuperarPasswordService = inject(recuperarPasswordService);
    private fb: FormBuilder = inject(FormBuilder);
    private confirmService: ConfirmationDialogService = inject(ConfirmationDialogService);
    private route: Router = inject(Router);
    private routeParams: ActivatedRoute = inject(ActivatedRoute);
    private zone: NgZone = inject(NgZone);
    private ipService = inject(IpService);
    private ip = '';

    constructor() {
        this.formReestablecer = this.fb.group({
            'usuario': [{ value: '', disabled: false }, [Validators.required]]
        });

        this.formCambio = this.fb.group({
            'pass': [{ value: '', disabled: false },
            [
                Validators.required,
                Validators.minLength(12),
                Validators.pattern(/^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[\W_]).+$/)
            ]
            ],
            'validarPass': [{ value: '', disabled: false },
            [
                Validators.required,
                Validators.minLength(12),
                Validators.pattern(/^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[\W_]).+$/)
            ]
            ]
        },
            {
                validators: this.matchValidator('pass', 'validarPass')
            });

        this.paramsC = { _Codigo: '', _Usuario: '' }
        this.routeParams.queryParams.subscribe((x: Params) => {
            // console.log('params', x);
            if (x) {
                this.paramsC = {
                    _Codigo: x['_Codigo'],
                    _Usuario: x['_Usuario']
                }
                if (this.paramsC._Codigo.length > 0 || this.paramsC._Usuario.length > 0) {
                    this.passBoolean = true;
                }
            }
        })

        this.ipService.getIPAddressPromise().then(
            (response) => {
                this.ip = response;
            }
        );
    }

    formReestablecer: FormGroup;
    formCambio: FormGroup;
    passBoolean = false;
    loading = false;
    paramsC: paramsInterface;

    /**
     * Función para cambiar la contraseña, se valida el formulario de cambio de contraseña, si es válido se construye un objeto con los datos del cambio y se llama al método reestablecerPassword del servicio
     * @returns 
     */
    cambioPass() {
        if (this.formCambio.invalid) {
            this.formCambio.markAllAsTouched();
            return;
        }

        const sendReestablecerPass: reestablecerPass = {
            _Codigo: this.paramsC._Codigo,
            _Usuario: this.paramsC._Usuario,
            Password: this.formCambio.get('validarPass')?.value,
            sIP: this.ip
        }
        this.loading = true;

        this.service.reestablecerPassword(sendReestablecerPass).subscribe({
            next: (respuesta: BaseReponseGeneric<boolean>) => {
                this.loading = false;

                if (respuesta.succcess) {
                    // eslint-disable-next-line @typescript-eslint/no-unused-vars                 
                    this.confirmService.confirm("", "Se reestableció la contraseña", "Ok", "").then(x => {
                        //Confirmacion no requerida
                    }).finally(() => {
                        this.route.navigateByUrl('/');
                    });
                }
                else {
                    // eslint-disable-next-line @typescript-eslint/no-unused-vars
                    this.confirmService.confirm("", respuesta.message, "Ok", "").then(x => {
                        //Confirmacion no requerida
                    });
                }
            }, error: (error: HttpErrorResponse) => {
                console.error('error,', error?.error?.message);
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                this.confirmService.confirm("", error?.error?.message, "Ok", "").then(x => {
                    //Confirmacion no requerida
                });
            }
            , complete: () => {
                this.loading = false;
            }
        });
    }

    /**
     * Función para enviar el correo de recuperación de contraseña, se valida el formulario de recuperación, si es válido se construye un objeto con los datos del usuario y se llama al método recuperarPass del servicio
     * @returns 
     */
    enviarCorreo() {

        if (this.formReestablecer.invalid) {
            this.formReestablecer.markAllAsTouched();
            return;
        }

        const sendUser: recuperarPassPost = {
            usuario: this.formReestablecer.get('usuario')?.value
        };
        this.loading = true;
        this.service.recuperarPass(sendUser).subscribe({
            next: (respuesta: BaseReponseGeneric<responseRecuperarPass>) => {
                //  console.log(respuesta);
                this.loading = false;

                if (respuesta.succcess) {
                    // eslint-disable-next-line @typescript-eslint/no-unused-vars
                    this.confirmService.confirm("", "Se envió correo", "Ok", "").then(x => {
                        //Confirmacion no requerida

                    }).finally(() => {
                        this.route.navigateByUrl('/');
                    });
                }
                else {
                    // eslint-disable-next-line @typescript-eslint/no-unused-vars
                    this.confirmService.confirm("", respuesta.message, "Ok", "").then(x => {
                        //Confirmacion no requerida

                    });
                }
            }, error: (error: HttpErrorResponse) => {
                console.error('error,', error.error.message);
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                this.confirmService.confirm("", error.error.message, "Ok", "").then(x => {
                    //Confirmacion no requerida

                });
            }
            , complete: () => {
                this.loading = false;
            }
        });
    }

    /**
     * Función para validar que dos campos coincidan
     * @param controlName 
     * @param matchingControlName 
     * @returns 
     */
    matchValidator(controlName: string, matchingControlName: string): ValidatorFn {
        return (abstractControl: AbstractControl) => {
            const control = abstractControl.get(controlName);
            const matchingControl = abstractControl.get(matchingControlName);

            if (matchingControl!.errors && !matchingControl!.errors?.['confirmedValidator']) {
                return null;
            }

            if (control!.value !== matchingControl!.value) {
                const error = { confirmedValidator: 'Passwords no coinciden.' };
                matchingControl!.setErrors(error);
                return error;
            } else {
                matchingControl!.setErrors(null);
                return null;
            }
        }
    }

    /**
     * Función para cancelar el proceso de recuperación de contraseña, se redirige al usuario a la página de login
      * @returns
     */
    Cancelar() {
        this.zone.run(() => {
            this.route.navigateByUrl('/login');
        });
    }

}